var Global = window;
function storage() {
    return Global.localStorage;
}

function read(key) {
    var data = storage().getItem(key);
    if(data) {
        return JSON.parse(data);
    }
    return undefined;
}

function write(key, data) {
    if(!data) {
        return;
    }
    data = JSON.stringify(data);
    return storage().setItem(key, data);
}

function each(fn) {
    for (var i = storage().length - 1; i >= 0; i--) {
        var key = storage().key(i);
        fn(read(key), key);
    }
}

function remove(key) {
    return storage().removeItem(key);
}

function clearAll() {
    return storage().clear();
}

export {
    read,
    write,
    each,
    remove,
    clearAll
};
export default {
    read,
    write,
    each,
    remove,
    clearAll
};